//hooks
import { useState } from 'react';
import { UserConsumer } from '../../hooks/context/UserContext';

//component
import UpdateProfile from '../../popup/UpdateProfile';
import CompletedRole from '../../popup/CompletedRole';

//mui
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';

//translate
import { useTranslation } from 'react-i18next';


//mui icon
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

const Profile = () => {
    let {userData, setTheme} = UserConsumer()
    const { t } = useTranslation();
    let [openUpdateProfile, setOpenUpdateProfile] = useState<boolean>(false)
    let [openCompletedProfile, setOpenCompletedProfile] = useState<boolean>(false)
    const handleComplete = (type:string)=>{
        setTheme(type)
        setOpenCompletedProfile(true)
    }
    return (
    <div>
        <div className="container mx-auto py-8">
            <div className="flex max-sm:flex-col gap-6 px-4">
                <div className="sm:w-[35%] sm:sticky sm:top-[120px] h-fit">
                    <div className="bg-white shadow-2xl rounded-lg p-6">
                        <div className="flex flex-col items-center">
                            <PersonOutlineIcon sx={{fontSize: "100px"}}/>
                            <h1 className="text-xl font-bold">{userData?.full_name}</h1>
                            <p className="text-gray-700">{userData?.email}</p>
                            <div className="mt-6">
                                <Fab onClick={()=>setOpenUpdateProfile(true)} className={`!w-[40px] !h-[40px] !bg-customerColor !text-white`} aria-label="edit">
                                    <EditIcon sx={{fontSize: "20px"}}/>
                                </Fab>
                                <UpdateProfile openUpdateProfile={openUpdateProfile} setOpenUpdateProfile={setOpenUpdateProfile}/>
                            </div>
                        </div>
                        <div className={`flex flex-col`}>
                            <hr className="my-6 border-t border-gray-300"/>
                            <span 
                            className={`text-gray-700 uppercase font-bold tracking-wider mb-2`}>
                                {userData?.is_client && userData?.is_driver && userData?.is_host 
                                ? t("update") 
                                :userData?.is_client || userData?.is_driver || userData?.is_host 
                                ? t("complete_and_update")
                                : t("complete")
                                }
                            </span>
                            <div className='flex flex-wrap justify-center text-center gap-2'>
                                <button onClick={()=>handleComplete("client")} className={`bg-customerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                    {userData?.is_client ? t("update_as_client") : t("complete_as_client")}
                                </button>
                                <button onClick={()=>handleComplete("driver")} className={`bg-paretnerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                    {userData?.is_driver ? t("update_as_driver") : t("complete_as_driver")}
                                </button>
                                <button onClick={()=>handleComplete("host")} className={`bg-paretnerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                    {userData?.is_host ? t("update_as_host") : t("complete_as_host")}
                                </button>
                            </div>
                            <CompletedRole openCompletedProfile={openCompletedProfile} setOpenCompletedProfile={setOpenCompletedProfile}/>
                        </div>
                    </div>
                </div>
                
                <div className='w-full'>
                    <div className="bg-white shadow-2xl rounded-lg p-6">
                        <h2 className="text-xl font-bold mb-4">{t("personal_info")}</h2>
                        <div className="text-gray-700">
                            <div className='flex gap-10 border-b border-gray-200 p-5'>
                                <p className='w-[100px] max-sm:w-[40px]'>{t("full_name")}</p>
                                <p className='max-sm:text-[13px]'>{userData?.full_name}</p>
                            </div>
                            <div className='flex gap-10 border-b border-gray-200 p-5'>
                                <p className='w-[100px] max-sm:w-[40px]'>{t("email")}</p>
                                <p className='max-sm:text-[13px]'>{userData?.email}</p>
                            </div>
                            <div className='flex gap-10 border-b border-gray-200 p-5'>
                                <p className='w-[100px] max-sm:w-[40px]'>{t("phone")}</p>
                                <p className='max-sm:text-[13px]'>{userData?.phone}</p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white shadow-2xl rounded-lg p-6">
                        <h2 className="text-xl font-bold mb-4">{t("personal_info")}</h2>
                        <div className="text-gray-700">
                            <div className='flex gap-10 border-b border-gray-200 p-5'>
                                <p className='w-[100px] max-sm:w-[40px]'>{t("full_name")}</p>
                                <p className='max-sm:text-[13px]'>{userData?.full_name}</p>
                            </div>
                            <div className='flex gap-10 border-b border-gray-200 p-5'>
                                <p className='w-[100px] max-sm:w-[40px]'>{t("email")}</p>
                                <p className='max-sm:text-[13px]'>{userData?.email}</p>
                            </div>
                            <div className='flex gap-10 border-b border-gray-200 p-5'>
                                <p className='w-[100px] max-sm:w-[40px]'>{t("phone")}</p>
                                <p className='max-sm:text-[13px]'>{userData?.phone}</p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white shadow-2xl rounded-lg p-6">
                        <h2 className="text-xl font-bold mb-4">{t("personal_info")}</h2>
                        <div className="text-gray-700">
                            <div className='flex gap-10 border-b border-gray-200 p-5'>
                                <p className='w-[100px] max-sm:w-[40px]'>{t("full_name")}</p>
                                <p className='max-sm:text-[13px]'>{userData?.full_name}</p>
                            </div>
                            <div className='flex gap-10 border-b border-gray-200 p-5'>
                                <p className='w-[100px] max-sm:w-[40px]'>{t("email")}</p>
                                <p className='max-sm:text-[13px]'>{userData?.email}</p>
                            </div>
                            <div className='flex gap-10 border-b border-gray-200 p-5'>
                                <p className='w-[100px] max-sm:w-[40px]'>{t("phone")}</p>
                                <p className='max-sm:text-[13px]'>{userData?.phone}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Profile